import {WithoutSummaryModel} from '../../../../common/entity/dto/plain/withoutSummary.model';
import {ProductSummaryModel} from '../../../api/entity/productSummary.model';
import {ProductRetrocessionRuleModel} from './productRetrocessionRule.model';
import {UserSummary} from '../../../../account/modules/user/api/entity/userSummary.model';

export class ProductRetrocessionRetrocessionModel extends WithoutSummaryModel {
    saleResponsibleUser: UserSummary;
    rules: ProductRetrocessionRuleModel[] = [];
}
